import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";

export const documentRecordStatus = v.union(
  v.literal("draft"),
  v.literal("completed"),
  v.literal("archived"),
);

export const documentRecordEntityType = v.union(
  v.literal("work_orders"),
  v.literal("clients"),
  v.literal("invoices"),
  v.literal("products"),
  v.literal("services"),
  v.literal("quotations"),
  v.literal("sales"),
  v.literal("suppliers"),
  v.literal("equipment"),
  v.literal("personnel"),
);

/**
 * Formato del documento en el editor markdown y en sus exportaciones (PDF):
 * formato y márgenes de página, fuente, tamaño e interlineado. Es metadata del
 * DOCUMENTO: cuando existe prevalece sobre las preferencias locales
 * (localStorage) del editor. Valores como string/number y validados en el
 * cliente, para no acoplar el schema a la lista de presets del editor.
 */
export const documentRecordLayout = v.object({
  pageFormat: v.optional(v.string()),
  pageMargin: v.optional(v.string()),
  fontFamily: v.optional(v.string()),
  fontSizePt: v.optional(v.number()),
  lineHeight: v.optional(v.number()),
});

export const validatorDocumentRecord = v.object({
  code: v.string(),
  templateId: v.optional(v.id("document_templates")),
  entityType: v.optional(documentRecordEntityType),
  entityId: v.optional(v.string()),
  title: v.string(),
  data: v.any(),
  status: documentRecordStatus,
  notes: v.optional(v.string()),
  layout: v.optional(documentRecordLayout),
  completedAt: v.optional(v.number()),
  completedBy: v.optional(v.id("users")),
  internalControl,
});

export const document_records = defineTableWithInternalControl(
  validatorDocumentRecord,
)
  .index("by_template", ["templateId"])
  .index("by_entity", ["entityType", "entityId"])
  .index("by_template_and_entity", ["templateId", "entityType", "entityId"])
  .index("by_status", ["status"])
  .index("by_code", ["code"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_company_and_entity", [
    "internalControl.companyId",
    "entityType",
    "entityId",
  ])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_company_and_template", ["internalControl.companyId", "templateId"])
  .searchIndex("search_document_records", {
    searchField: "title",
    filterFields: [
      "internalControl.companyId",
      "entityType",
      "status",
      "templateId",
    ],
  });
